import styled from 'styled-components'
const CodeBlock = styled.pre`
    @import url(a-google-font-url);
    font-family: 'Source Code Pro', monospace;
    background-color: #000;
    color: #fafafa;
    padding: 20px;
    border-radius: 5px;
    display: block;
    overflow-x: auto;
    margin-right: 25px;
    margin-left: 25px;
`
export default CodeBlock;